import React from 'react';
import { Router as DefaultRouter, Route, Switch } from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/_renderRoutes';
import RendererWrapper0 from '/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/pages/.umi-production/LocaleWrapper.jsx'
import _dvaDynamic from 'dva/dynamic'

let Router = require('dva/router').routerRedux.ConnectedRouter;

let routes = [
  {
    "path": "/dat-hang-nhanh",
    "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__QuickOrderLayout" */'../../layouts/QuickOrderLayout'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
    "exact": true
  },
  {
    "path": "/s/:code",
    "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__ShareTripLayout" */'../../layouts/ShareTripLayout'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
    "exact": true
  },
  {
    "path": "/user",
    "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__UserLayout" */'../../layouts/UserLayout'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
    "routes": [
      {
        "path": "/user/login",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__User__Login" */'../User/Login'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/user/sms-login",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__User__SmsLogin" */'../User/SmsLogin'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/user/recovery",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__User__RecoveryPassword" */'../User/RecoveryPassword'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/user/accept",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__User__RecoveryPassword__Accept" */'../User/RecoveryPassword/Accept'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/user/reset-password",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__User__NewPassword" */'../User/NewPassword'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/user/forgot-password",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__User__NewPassword" */'../User/NewPassword'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/user*",
        "redirect": "/user/login",
        "exact": true
      }
    ]
  },
  {
    "path": "/information",
    "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__Information" */'../../layouts/Information.js'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
    "Routes": [require('../Authorized').default],
    "authority": [
      "superadmin",
      "admin",
      "user",
      "owner",
      "coordinator"
    ],
    "routes": [
      {
        "path": "/information",
        "redirect": "/information/e-contract",
        "exact": true
      },
      {
        "path": "/information/e-contract",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__EContract" */'../EContract'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      }
    ]
  },
  {
    "path": "/",
    "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__BasicLayout" */'../../layouts/BasicLayout'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
    "Routes": [require('../Authorized').default],
    "authority": [
      "superadmin",
      "admin",
      "user",
      "owner",
      "coordinator"
    ],
    "routes": [
      {
        "path": "/",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__Home__Home" */'../Home/Home'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/deliveries",
        "name": "deliveries",
        "icon": "environment",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__Deliveries" */'../Deliveries'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/dashboard",
        "name": "dashboard",
        "icon": "pie-chart",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__Dashboard" */'../Dashboard'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/order",
        "name": "order",
        "icon": "unordered-list",
        "routes": [
          {
            "path": "/order",
            "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__BasicLayout" */'../OrderList'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
            "exact": true
          },
          {
            "path": "/order/:id",
            "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__BasicLayout" */'../OrderDetail'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
            "exact": true
          },
          {
            "path": "/order/:id/delivery-orders",
            "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__BasicLayout" */'../DeliveryOrders'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
            "exact": true
          }
        ]
      },
      {
        "path": "/order-new",
        "name": "create_new_order",
        "icon": "plus-square",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__OrderCreation" */'../OrderCreation'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/b2b-order",
        "name": "create_b2b_order",
        "icon": "diff",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__B2BOrderForm__Create" */'../B2BOrderForm/Create'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "authority": [
          "enterprise"
        ],
        "routes": [
          {
            "path": "/b2b-order/:id/edit",
            "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__B2BOrderForm__Create" */'../B2BOrderForm/Edit'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
            "exact": true
          }
        ]
      },
      {
        "path": "/https:/import-booking",
        "name": "auto_create_booking",
        "icon": "file-excel",
        "authority": [
          "enterprise"
        ],
        "exact": true
      },
      {
        "path": "/document",
        "name": "document_management",
        "icon": "file-image",
        "routes": [
          {
            "path": "/document",
            "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__BasicLayout" */'../DocumentManagement'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
            "exact": true
          },
          {
            "path": "/document/:id",
            "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "layouts__BasicLayout" */'../DocumentDetail'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
            "exact": true
          }
        ]
      },
      {
        "name": "profile",
        "icon": "user",
        "path": "/profile",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__Profile" */'../Profile'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "path": "/shipment/:id",
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__Shipment" */'../Shipment'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      },
      {
        "component": _dvaDynamic({
  
  component: () => import(/* webpackChunkName: "p__404" */'../404'),
  LoadingComponent: require('/home/runner/work/logivan-shippers-webapp/logivan-shippers-webapp/src/components/common/PageLoading/index').default,
}),
        "exact": true
      }
    ]
  }
];
window.g_plugins.applyForEach('patchRoutes', { initialValue: routes });

export default function RouterWrapper() {
  return (
<RendererWrapper0>
          <Router history={window.g_history}>
      { renderRoutes(routes, {}) }
    </Router>
        </RendererWrapper0>
  );
}
